// src/services/classVisibility.js
// Single source of truth for the class visibility allowlist.
// See docs/decisions/adr-class-visibility-and-premiere-sync.md.
//
// A class OR recording carrying a non-empty `visibleToUserIds` array is visible
// ONLY to admins and to the Clerk user IDs in that array. Absent / null / empty
// ⇒ PUBLIC — the historical default — so every pre-existing class and recording
// (which has no such field) behaves exactly as before. This function is the ONLY
// place the visibility decision is made; every gate site calls it.

export function canSeeClass(item, { userId, isAdmin } = {}) {
    const list = item && item.visibleToUserIds;
    // Public: no allowlist set. Identical to pre-feature behavior.
    if (!Array.isArray(list) || list.length === 0) return true;
    // Admin always sees gated classes (management, cleanup, viewer-preview).
    if (isAdmin === true) return true;
    // Gated: visible only to a signed-in user explicitly on the allowlist.
    if (!userId || typeof userId !== 'string') return false;
    return list.includes(userId);
}
